// extracted by mini-css-extract-plugin
export default {"vspinInstrumentPage":"vspinInstrumentPage-f67Sf","genericInstrumentPage":"genericInstrumentPage-zOxtf","bodyContents":"bodyContents-J0cRh"};